import classNames from 'classnames';
import { ButtonHTMLAttributes, FC } from 'react';

import { getButtonClassName } from './helpers';
import { ButtonStyleProps } from './types';
import Caret from '../icons/Caret';
import Loading from '../icons/Loading';

type HtmlButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export type ButtonProps = ButtonStyleProps & HtmlButtonProps;

import style from './button.module.css';

const Button: FC<ButtonProps> = ({
  buttonColor,
  caretProps,
  children,
  hideCaret = false,
  isLoading = false,
  variant,
  ...htmlButtonProps
}) => {
  const buttonClassName = getButtonClassName({
    buttonColor,
    variant,
  });

  return (
    <button
      {...htmlButtonProps}
      className={classNames(
        buttonClassName,
        htmlButtonProps.className,
        style.buttonWithLoading,
      )}
      disabled={isLoading || htmlButtonProps.disabled}
    >
      <span
        className={classNames(
          style.buttonContent,
          {
            [style.buttonContentLoading]: isLoading,
          },
        )}
      >
        {children}

        {!hideCaret && <Caret {...caretProps} />}
      </span>

      <Loading
        className={classNames(
          style.buttonLoading,
          {
            [style.buttonLoadingLoading]: isLoading,
          },
        )}
      />
    </button>
  );
};

export default Button;
